<template>
  <div class="option-end">
    <h4>
      <i class="el-icon-minus"></i>
      オプション 終了
    </h4>
  </div>
</template>

<script>
export default {
  name: "OptionEnd",
  props: {
    act: Object
  }
};
</script>
